/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/survey/stats" endpoint
 */
import fetch from "@lib/fetch";

import { createGetFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createGetFetcherFunctionWithShadowError";
import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdSurveyStats } from "./constants";
import type {
  GetEngagementAppGroupIdSurveyStatsResult,
  GetEngagementAppGroupIdSurveyStatsResultErrors,
  GetEngagementAppGroupIdSurveyStatsParams,
} from "./types";
import { isGetEngagementAppGroupIdSurveyStatsResult } from "./validators";

export const getEngagementAppGroupIdSurveyStats = reactQueryFetcherAdapter(
  engagementAppGroupIdSurveyStats,
  createGetFetcherFunctionWithShadowError<GetEngagementAppGroupIdSurveyStatsResultErrors>()(
    (
      signal: AbortSignal,
      {
        appGroupId,
        campaignId,
        messageVariationId,
        landingPageId,
        startDate,
        endDate,
      }: GetEngagementAppGroupIdSurveyStatsParams
    ): Promise<GetEngagementAppGroupIdSurveyStatsResult> => {
      return fetch(
        `/engagement/${appGroupId}/survey/stats`,
        "GET",
        {
          campaign_base_id: campaignId,
          message_variation_id: messageVariationId,
          landing_page_id: landingPageId,
          start_date: startDate,
          end_date: endDate,
        },
        { signal }
      );
    }
  ),
  isGetEngagementAppGroupIdSurveyStatsResult
);
